export default "__VITE_ASSET__DWrlYoIh__"